import React, {Suspense} from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Page } from "./types";
import ScrollToTop from "./ScrollToTop";
import Footer from "shared/Footer/Footer";
import PageHome from "containers/PageHome/PageHome";
import Page404 from "containers/Page404/Page404";
import ListingStayPage from "containers/ListingStayPage/ListingStayPage";
import ListingStayMapPage from "containers/ListingStayPage/ListingStayMapPage";
import CheckOutPage from "containers/CheckOutPage/CheckOutPage";
import PayPage from "containers/PayPage/PayPage";
import AuthorPage from "containers/AuthorPage/AuthorPage";
import AccountPage from "containers/AccountPage/AccountPage";
import AccountPass from "containers/AccountPage/AccountPass";
import AccountSavelists from "containers/AccountPage/AccountSavelists";
import AccountBilling from "containers/AccountPage/AccountBilling";
import PageContact from "containers/PageContact/PageContact";
import PageAbout from "containers/PageAbout/PageAbout";
import PageSignUp from "containers/PageSignUp/PageSignUp";
import PageLogin from "containers/PageLogin/PageLogin";
import PageSubcription from "containers/PageSubcription/PageSubcription";
import BlogPage from "containers/BlogPage/BlogPage";
import BlogSingle from "containers/BlogPage/BlogSingle";
import SiteHeader from "containers/SiteHeader";
import FooterNav from "components/FooterNav";
import useWindowSize from "hooks/useWindowResize";
import ListingStayDetailPage from "containers/ListingDetailPage/listing-stay-detail/ListingStayDetailPage";
import ForgotPass from "containers/ForgotPassword/ForgotPass";
import SendVerificationCode from "containers/ForgotPassword/SendVerificationCode";
import Reservation from "containers/ListingDetailPage/listing-stay-detail/Reservation";
import GuestForm from "containers/ListingDetailPage/listing-stay-detail/GuestForm";
import Payment from "containers/CheckOutPage/ReservationPayment";
import BookingPayments from "containers/AccountPage/CompleteBookingPayment"; 
import EditReservation from "containers/AccountPage/EditReservation";
import PastBookings from "containers/AccountPage/PastBookings";
import FamilyGroup from "containers/AccountPage/FamilyGroup";
import PartialPayment from "containers/AccountPage/PartialPayment";
import CompletePayment from "containers/AccountPage/CompletePayment";
import AccountDocuments from "containers/AccountPage/AccountDocuments";
import CheckInPage from "containers/CheckInPage/CheckinPage";
import ValidatePhone from "containers/PageLogin/ValidatePhone";
import  MercadopagoReservation  from "components/Mercadopago/MercadopagoReservation";
import MercadopagoCompletePayment from "components/Mercadopago/MercadopagoCompletePayment";
import TransferPayment from "containers/CheckOutPage/TransferPayment";
import StatusPage from "containers/PagePaymentStatus/PaymentStatusPage";


export const pages: Page[] = [
  { path: "/", exact: true, component: PageHome },
  { path: "/#", exact: true, component: PageHome },
  { path: "/home-1-header-2", exact: true, component: PageHome },
  { path: "/listing-stay", component: ListingStayPage },
  { path: "/listing-stay-map", component: ListingStayMapPage },
  { path: "/listing-stay-detail", component: ListingStayDetailPage },
  { path: "/rooms-distribution", component: Reservation },
  { path: "/guest-form", component: GuestForm },
  { path: "/checkout", component: CheckOutPage },
  { path: "/payment", component: Payment },
  { path: "/pay-done", component: PayPage },
  { path: "/booking-payments", component: BookingPayments },
  { path: "/author", component: AuthorPage },
  { path: "/account", component: AccountPage },
  { path: "/account-password", component: AccountPass },
  { path: "/account-savelists", component: AccountSavelists },
  { path: "/account-billing", component: AccountBilling },
  { path: "/reservation-account-status", component: EditReservation },
  { path: "/past-bookings", component: PastBookings },
  { path: "/partial-payment", component: PartialPayment },
  { path: "/complete-payment", component: CompletePayment },
  { path: "/my-family-group", component: FamilyGroup },
  { path: "/account-documents", component: AccountDocuments },
  { path: "/blog", component: BlogPage },
  { path: "/blog-single", component: BlogSingle },
  { path: "/contact", component: PageContact },
  { path: "/about", component: PageAbout },
  { path: "/signup", component: PageSignUp },
  { path: "/login", component: PageLogin },
  { path: "/subscription", component: PageSubcription },
  { path: "*", component: Page404 },
  { path: "/forgot-pass", component: ForgotPass },
  { path: "/recover", component: SendVerificationCode },
  { path: "/checkin", component: CheckInPage },
  { path: "/activate-phone", component: ValidatePhone },
  { path: "/mercadopago-form", component: MercadopagoReservation },
  { path: "/mercadopago-complete-payment", component: MercadopagoCompletePayment },
  { path: "/transfer-payment", component: TransferPayment },
  { path: "/success", component: () => <StatusPage type="success" /> },
  { path: "/failure", component: () => <StatusPage type="failure" /> },
  { path: "/pending", component: () => <StatusPage type="pending" /> },

];

// Componente Loading
const Loading = () => <div>Loading...</div>;
 

const MyRoutes = () => {
  let WIN_WIDTH = useWindowSize().width;
  if (typeof window !== "undefined") {
    WIN_WIDTH = WIN_WIDTH || window.innerWidth;
  }
  

  return (
    <BrowserRouter>
      <ScrollToTop />
      <SiteHeader />
      <Suspense fallback={<Loading />}>
        <Routes>
          {pages.map(({ component, path }) => {
            const Component = component;
            return <Route key={path} element={<Component />} path={path} />;
          })}
          <Route path="*" element={<Page404 />} />
        </Routes>
      </Suspense>
      {WIN_WIDTH < 1024 && <FooterNav />}
      <Footer />
    </BrowserRouter>
  );
};

export default MyRoutes;
